export function applyCSSVariables(backgroundString) {
  // linear-gradient(360deg,p 0%, s 75%, t 100%)
  // gradient(360deg,var(--startup-primary-color) 0%, var(--startup-secondary-color) 75%, var(--startup-tertiary-color) 100%)
  return backgroundString
    .replaceAll('{p}', 'var(--startup-primary-color)')
    .replaceAll('{s}', 'var(--startup-secondary-color)')
    .replaceAll('{t}', 'var(--startup-tertiary-color)')
    .replaceAll('{b}', 'var(--startup-primary-background-color)')
    .replaceAll('{sb}', 'var(--startup-secondary-background-color)')
    .replaceAll('{tt}', 'var(--startup-text-color)');
}

export function repalceCSSVariables(backgroundString) {
  // linear-gradient(360deg,p 0%, s 75%, t 100%)
  // gradient(360deg,var(--startup-primary-color) 0%, var(--startup-secondary-color) 75%, var(--startup-tertiary-color) 100%)
  return backgroundString
    .replaceAll('var(--startup-primary-color)', '{p}')
    .replaceAll('var(--startup-secondary-color)', '{s}')
    .replaceAll('var(--startup-tertiary-color)', '{t}')
    .replaceAll('var(--startup-primary-background-color)', '{b}')
    .replaceAll('var(--startup-secondary-background-color)', '{sb}')
    .replaceAll('var(--startup-text-color)', '{tt}');
}